// Customer pet photos (background removed) used on the personalized keychain
// product page to showcase real pets we've turned into pendants.
// Files live in webfrontend/public/images/ljubimci/.
const FILENAMES = [
  'img_69e3910b9b0ca7.07115873_1776521483_nobg.png',
  'img_69e7255d46c550.77752163_1776756061_nobg.png',
  'img_69e735f2008319.25749771_1776760306_nobg.png',
  'img_69e8883cb16987.86773025_1776846908_nobg.png',
  'img_69ea64c7159f61.94167446_1776968903_nobg.png',
  'img_69eb13a4a68033.65008116_1777013668_nobg.png',
  'img_69eb4bc8a61651.19513161_1777028040_nobg.png',
  'img_69ee2988168a89.82596448_1777215880_nobg.png',
  'img_69f2509356a027.80598857_1777488019_nobg.png',
  'img_69f33f4cad1d32.81707609_1777549132_nobg.png',
  'img_69f45ab02a9a87.10808565_1777621680_nobg.png',
  'img_69f6450ddb53d4.79052855_1777747213_nobg.png',
  'img_69f724260d90c6.31898652_1777804326_nobg.png',
  'img_69f8ebf0226659.21622342_1777921008_nobg.png',
  'img_69fb364f1e8c07.37153227_1778071119_nobg.png',
  'img_6a08cb8fc697c1.61141245_1778961295_nobg.png',
  'img_6a201f2e2e7bb2.68052258_1780490030_nobg.png',
  'img_6a2055994daad8.45843215_1780503961_nobg.png',
  'img_6a206b6c09cb30.60631083_1780509548_nobg.png',
  'img_6a207bf633eca9.71886019_1780513782_nobg.png',
  'img_6a22a4db3492b2.56524967_1780655323_nobg.png',
  'img_6a22c837cb1339.00818345_1780664375_nobg.png',
  'img_6a24134c30b0d6.18006577_1780749132_nobg.png',
  'img_6a2420283abe03.79792259_1780752424_nobg.png',
  'img_6a242277973ac1.77991235_1780753015_nobg.png',
  'img_6a270105c86e14.43373146_1780941061_nobg.png',
  'img_6a270105c8be80.47180400_1780941061_nobg.png',
  'img_6a27fedb5490f0.97956392_1781006043_nobg.png',
  'img_6a2810ec88b0e5.75338671_1781010668_nobg.png',
  'img_6a326b9a89e3b9.87498695_1781689242_nobg.png',
  'img_6a351e253cdcd3.39427063_1781866021_nobg.png',
  'img_6a35479bc85a13.54762453_1781876635_nobg.png',
  'img_6a358456246e43.07120466_1781892182_nobg.png',
  'img_6a35845624d9d6.56365487_1781892182_nobg.png',
  'img_6a3652c8d6e6e5.36185379_1781945032_nobg.png',
  'img_6a39295aeefe62.59335849_1782131034_nobg.png',
  'img_6a3931b9f3a863.09896454_1782133177_nobg.png',
  'img_6a39b679caff49.45453948_1782167161_nobg.png',
  'img_6a3aeedc38f7b7.49479776_1782247132_nobg.png',
  'img_6a3aeedc390d55.39897852_1782247132_nobg.png',
  'img_6a3b97484cdfa0.72471727_1782290248_nobg.png',
  'img_6a3cd99d3cb4c4.49240114_1782372765_nobg.png',
  'img_6a3e6a42065727.68802084_1782475330_nobg.png',
  'img_6a3eb7e27cb6c0.32321099_1782495202_nobg.png',
  'img_6a3ee62a4b3004.68818140_1782507050_nobg.png',
  'img_6a4005bd0e9397.56501458_1782580669_nobg.png',
  'img_6a405604984922.04393366_1782601220_nobg.png',
  'img_6a413aa4b05b37.31223579_1782659748_nobg.png',
  'img_6a4198f47f1878.13423655_1782683892_nobg.png',
  'img_6a54fe1616b487.35269957_1783954966_nobg.png',
  'img_6a54fe1616fb49.74442209_1783954966_nobg.png',
];

// Pre-cropped (transparent margin trimmed) + downscaled + WebP-encoded
// versions of the same photos — ~95% smaller, sized for the small sticker
// display instead of the original upload resolution.
const IMG_DIR = '/images/ljubimci/optimized';

export const PET_STICKER_IMAGES = FILENAMES.map(
  (name) => `${IMG_DIR}/${name.replace(/\.png$/i, '.webp')}`
);
